module.exports = __webpack_public_path__ + "img/Anna.7a09a77f.png";